import React, { useEffect, useState, useRef, useCallback } from "react";
import { useSelector } from "react-redux";
import CmnFilters from "../../lead-management/common/CmnFilters";
import CommonStructured from "../../common-components/CommonStructured";
import { currentDateOfTheMonth } from "../../common-data/Converts";
import HygineTaskOverview from "../hygiene-form/hygine-task-overview/HygineTaskOverview";
import { hygieneAsignee } from "../../common-data/DropdowData";
import { extractTimesFromArray } from "../hygiene-form/hygine-task-overview/HygieneMocksData";
import { isManagerRole as checkIsManagerRole } from "../../common-data/Conversions";

const TaskListings = ({ userInfoData }) => {
  const { hygineTaskLogsLoading } = useSelector((state) => state.hygiene);

  const apiCallRefs = useRef([]);

  const isAdmin = userInfoData?.account_type === "admin";
  const isGym = userInfoData?.account_type === "gym";
  const isFDTrainer =
    userInfoData?.account_type === "receptionist" ||
    userInfoData?.account_type === "trainer";
  const isManagerRole = checkIsManagerRole(userInfoData);

  const iniAllFilter = {
    selectedGym: !isAdmin && !isManagerRole
      ? {
          label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
          value:
            userInfoData?.gym_id ||
            userInfoData?.user_id ||
            userInfoData?.uid ||
            "",
        }
      : "",
    selAddedby: "",
    selectedHygineCategory: "",
    selectedCheckinTime: [],
    selectedTaskPriority: "",
    selAssignee: isFDTrainer
      ? hygieneAsignee.find(
          (item) => item.value === userInfoData?.account_type
        ) || ""
      : "",
    selectedNotifyStatus: "",
    searchString: "",
    leadAddDateFrom: currentDateOfTheMonth,
    leadAddDateTo: currentDateOfTheMonth,
    // selectedStartDate: currentDateOfTheMonth,
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    gym_id: allFilters.selectedGym?.value || "",
    category: allFilters.selectedHygineCategory?.value || "",
    aprv_rej_by: allFilters.selAddedby?.value || "",
    task_time_filter: "",
    priority: allFilters.selectedTaskPriority?.value || "",
    stakeholders: allFilters.selAssignee?.value || "",
    media_required: allFilters.selectedNotifyStatus?.value || "",
    task_date_from: allFilters.leadAddDateFrom || "",
    task_date_to: allFilters.leadAddDateTo || "",
    // task_date: allFilters.selectedStartDate || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);

  const registerApiCall = useCallback((apiCall) => {
    if (!apiCallRefs.current.includes(apiCall)) {
      apiCallRefs.current.push(apiCall);
    }
  }, []);

  const handleReload = () => {
    apiCallRefs.current.forEach((apiCall) => apiCall());
  };

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
    setFilters(iniFilters);
    setSearchFilterApplied(false);
  };

  const onClickSearch = () => {
    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  useEffect(() => {
    setAllFilters((prevs) => ({
      ...prevs,
      selectedGym: !isAdmin
        ? {
            label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
            value:
              userInfoData?.gym_id ||
              userInfoData?.user_id ||
              userInfoData?.uid ||
              "",
          }
        : "",
    }));
  }, [userInfoData?.gym_id]);

  useEffect(() => {
    const { start_end_time } = extractTimesFromArray(
      allFilters.selectedCheckinTime
    );

    setFilters((prevs) => ({
      ...prevs,
      gym_id: allFilters.selectedGym?.value || "",
      category: allFilters.selectedHygineCategory?.value || "",
      aprv_rej_by: allFilters.selAddedby?.value || "",
      task_time_filter: start_end_time || "",
      priority: allFilters.selectedTaskPriority?.value || "",
      stakeholders: allFilters.selAssignee?.value || "",
      media_required: allFilters.selectedNotifyStatus?.value || "",
      task_date_from: allFilters.leadAddDateFrom || "",
      task_date_to: allFilters.leadAddDateTo || "",
      // task_date: allFilters.selectedStartDate || "",
    }));
  }, [
    allFilters.selectedGym,
    allFilters.selectedHygineCategory,
    allFilters.selAddedby,
    allFilters.selectedTaskPriority,
    allFilters.selAssignee,
    allFilters.selectedNotifyStatus,
    allFilters.selectedCheckinTime,
    allFilters.leadAddDateFrom,
    allFilters.leadAddDateTo,
    // allFilters.selectedStartDate,
  ]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
    }
  }, [allFilters.searchString]);

  return (
    <>
      <CommonStructured
        pageHeading="Daily Operation Checklist"
        isReload={handleReload}
      />

      <CmnFilters
        from="hygiene-taks-tabwise"
        userInfoData={userInfoData}
        onClickReset={onResetFilters}
        filters={allFilters}
        setFilters={setAllFilters}
        onClickSearch={onClickSearch}
        searchFilterApplied={searchFilterApplied}
        isLoading={hygineTaskLogsLoading}
        searchPlaceHolder="Search By Task Name..."
      />

      <HygineTaskOverview
        isAdminPage={true}
        userInfoData={userInfoData}
        prevFilters={filters}
        // taskDate={filters.task_date}
        // gymID={filters.gym_id}
        registerApiCall={registerApiCall}
      />
    </>
  );
};

export default TaskListings;
